var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Điều khoản sử dụng",
            "before-close": _vm.handleClose,
            visible: _vm.isTermsOfUseDialog,
            "show-close": true,
            "close-on-click-modal": false,
            width: "700px",
            top: "20vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isTermsOfUseDialog = $event
            },
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "line-height": "1.6",
                "word-break": "break-word",
                "white-space": "normal",
              },
            },
            [
              _c("p", [
                _vm._v(
                  "\n        Quý Khách hàng hiện đang sử dụng dịch vụ nhận thông báo biến động số dư tài khoản ngân hàng được tích hợp trong phần mềm\n        "
                ),
                _c("strong", [_vm._v("OneKids")]),
                _vm._v(", do đối tác trung gian của OneKids cung cấp.\n      "),
              ]),
              _c("p", [
                _vm._v("\n        Căn cứ quy định tại "),
                _c("strong", [_vm._v("Nghị định số 13/2023/NĐ-CP")]),
                _vm._v(
                  " về bảo vệ dữ liệu cá nhân, nhằm đảm bảo việc tuân thủ quy định pháp luật liên quan đến bảo mật thông tin,\n        "
                ),
                _c("strong", [_vm._v("OneKids")]),
                _vm._v(
                  " xin xác nhận sự đồng thuận từ Quý Khách hàng đối với các nội dung sau trước khi sử dụng dịch vụ, cụ thể:\n      "
                ),
              ]),
              _c("ol", { staticStyle: { "padding-left": "20px" } }, [
                _c("li", [
                  _vm._v("\n          Tôi đồng ý cho phép "),
                  _c("strong", [_vm._v("OneKids")]),
                  _vm._v(
                    ", thông qua đối tác được ủy quyền, cung cấp và chia sẻ thông tin cần thiết với ngân hàng nơi tôi đang sử dụng tài khoản,\n          nhằm mục đích đăng ký và kích hoạt dịch vụ nhận thông báo biến động số dư.\n        "
                  ),
                ]),
                _c("li", [
                  _vm._v("\n          Tôi đồng ý cho phép "),
                  _c("strong", [_vm._v("OneKids")]),
                  _vm._v(
                    " và đối tác trung gian tiếp nhận dữ liệu giao dịch phát sinh từ tài khoản ngân hàng của tôi,\n          giới hạn trong phạm vi hiển thị thông tin trên phần mềm OneKids phục vụ mục đích quản lý thanh toán.\n        "
                  ),
                ]),
                _c("li", [
                  _vm._v(
                    "\n          Tôi xác nhận đã đọc, hiểu rõ và đồng ý để ngân hàng cung cấp thông tin liên quan đến trạng thái giao dịch của tài khoản cho đối tác trung gian và "
                  ),
                  _c("strong", [_vm._v("OneKids")]),
                  _vm._v(
                    ".\n          Đồng thời, tôi chấp thuận với\n          "
                  ),
                  _c(
                    "a",
                    {
                      staticStyle: {
                        color: "#409EFF",
                        "text-decoration": "underline",
                      },
                      attrs: {
                        href: "https://onekids.edu.vn/bdsd_dieu_khoan",
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n            toàn bộ điều kiện và điều khoản sử dụng dịch vụ\n          "
                      ),
                    ]
                  ),
                  _vm._v(".\n        "),
                ]),
              ]),
              _c("p", { staticStyle: { color: "red", "font-weight": "500" } }, [
                _vm._v(
                  "\n        * Bằng việc nhấn vào nút “Có, tôi đồng ý” bên dưới, Quý Khách hàng xác nhận đã hiểu rõ, đồng ý và chấp thuận toàn bộ nội dung nêu trên.\n      "
                ),
              ]),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "info", size: "medium" },
                  on: { click: _vm.handleClose },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _c("span", [_vm._v("Không đồng ý")]),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "medium",
                    loading: _vm.loading.submit,
                  },
                  on: { click: _vm.submitForm },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-check" }),
                  _c("span", [_vm._v("Có, tôi đồng ý")]),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        [
          _c("OTPAuthenticationDialog", {
            attrs: {
              bank: _vm.bank,
              response: _vm.response,
              isOTPAuthenticationDialog: _vm.isOTPAuthenticationDialog,
            },
            on: { closeDialog: _vm.handleClose },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }